import { FC } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { headerData } from '../../assets/headerData';
import xicon from '../../assets/images/svg/xicon.svg';
import phone from '../../assets/images/svg/phone.svg';
import styles from './Header.module.scss';

interface HeaderMobileProps {
  isOpenMenu: boolean;

  setIsOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

export const HeaderMobile: FC<HeaderMobileProps> = ({ isOpenMenu, setIsOpenMenu }) => {
  const variants = {
    open: {
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.1,
        type: 'spring',
        stiffness: 400,
        damping: 40,
      },
    },
    closed: {
      opacity: 0.5,
      x: '100%',
      transition: {
        type: 'spring',
        stiffness: 60,
        restDelta: 10,
      },
    },
  };

  const listItemVariants = {
    closed: {
      x: -30,
      opacity: 0,
    },
    open: {
      x: 0,
      opacity: 0.8,
    },
  };
  return (
    <motion.nav
      animate={isOpenMenu ? 'open' : 'closed'}
      initial="closed"
      variants={variants}
      className={clsx('fixed   bg-white top-0 left-0 right-0 bottom-0 z-40')}
    >
      {isOpenMenu && (
        <div className={clsx(' flex  px-auto md:flex-none ')}>
          <div className={clsx(styles.inner)}>
            <img
              onClick={() => setIsOpenMenu(!isOpenMenu)}
              src={xicon}
              width={30}
              alt=""
              className=" mb-5 cursor-pointer"
            />

            {headerData.map((nav, index) => (
              <motion.div
                variants={listItemVariants}
                transition={{ delay: index / 4 }}
                key={nav.title}
                className="text-gray-950  rounded  hover:text-gray-500 hover:font-medium py-2 px-2 md:mx-2"
                onClick={() => setIsOpenMenu(!isOpenMenu)}
              >
                <Link to={nav.path}>{nav.title}</Link>
              </motion.div>
            ))}

            <a href="tel:+1-425-589-9676" className="mt-5">
              <img src={phone} alt="" width={20} />
            </a>
          </div>
        </div>
      )}
    </motion.nav>
  );
};
